import axiosInstance from "@/utils/AxiosInstance";
import {NewQuantityTable} from "@/services/quantityTables/entities/NewQuantityTable";

const BASE_API = '/tables';

const updateQuantityTable = async (body: NewQuantityTable): Promise<any> => {
    return await axiosInstance.post(`${BASE_API}/`, body);
}

const getQuantityTableTypes = async (): Promise<any> => {
    return await axiosInstance.get(`${BASE_API}/types`);
}

export default {
    updateQuantityTable,
    getQuantityTableTypes,
}